import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Compass, Loader2, AlertTriangle } from "lucide-react";
import { useUser } from "@/context/UserContext";
import { Button } from "@/components/ui/button";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const { completeGoogleLogin } = useUser();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) { navigate("/", { replace: true }); return; }
    (async () => {
      try {
        await completeGoogleLogin(sessionId);
        window.history.replaceState(null, "", window.location.pathname);
        const returnTo = sessionStorage.getItem("zk_return_to") || "/";
        sessionStorage.removeItem("zk_return_to");
        navigate(returnTo, { replace: true });
      } catch (e) {
        setError(e.response?.data?.detail || "Aanmelden met Google is mislukt.");
      }
    })();
  }, [completeGoogleLogin, navigate]);

  if (error) {
    return (
      <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center p-6">
        <div data-testid="google-auth-error" className="max-w-sm w-full bg-white border border-slate-200 rounded-2xl p-8 text-center shadow-sm">
          <div className="w-12 h-12 rounded-xl bg-red-50 flex items-center justify-center mx-auto mb-4">
            <AlertTriangle className="w-6 h-6 text-red-600" />
          </div>
          <h2 className="font-heading text-xl font-bold text-slate-900">Aanmelden mislukt</h2>
          <p className="text-sm text-slate-500 mt-2">{error}</p>
          <Button data-testid="google-error-back" onClick={() => { window.location.href = "/"; }} className="w-full mt-6 bg-slate-900">
            Terug naar inloggen
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex flex-col items-center justify-center gap-4" data-testid="google-auth-callback">
      <div className="flex items-center gap-2 text-slate-900">
        <Compass className="w-6 h-6" />
        <span className="font-heading font-bold text-lg">Zoetwaren Kompas</span>
      </div>
      <div className="flex items-center gap-2 text-slate-500 text-sm">
        <Loader2 className="w-4 h-4 animate-spin" /> Bezig met aanmelden…
      </div>
    </div>
  );
};

export default AuthCallback;
